import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { TopUpService } from '../services/top-up.service';
import { finalize } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { ContactService } from '../services/contact.service';
@Component({
  selector:'app-topUp',
  standalone:true,
  imports:[
  CommonModule,
  FormsModule,
  MatAutocompleteModule,
  MatInputModule
],
  template:
  `
     <div class="spinner-container" *ngIf="isLoadingPageContent">
      <span class="spinner"></span>
    </div>
    <div *ngIf="showPageContent">
      <!-- TOP UP OPTIONS -->
      <div class="line-segment" *ngIf="(showTopUpMethods || showPayerSection) && !showAddNewContact">
        <div [class.selected]="topUpMode==='topUp'"
            (click)="changeBuyMode('topUp')">
          Top up
        </div>
        <div [class.selected]="topUpMode==='topMeUp'"
            (click)="changeBuyMode('topMeUp')">
          Top me up
        </div>
      </div>

      <!--TOP UP METHODS -->
      <div *ngIf="showTopUpMethods">
        <div class="section-title">
          Select top up method
        </div>
        <div class="category-option" *ngFor="let p of topUpMethods"
          [class.selected]="selectedTopUpMethod === p"
          (click)="selectTopUpMethod(p)">
          <div class="payment-option-left">
            <span>{{ p.name }}</span>
          </div>
          <img [src]="'assets/images/' + p.logo" class="payment-option-logo">
        </div>
      </div>

      <!-- TOP ME UP -->
      <div *ngIf="showPayerSection">
        <div *ngIf="!selectedContact && !showAddNewContact">
          <div class="title">Select payer</div>
          <!-- ADD CONTACT BUTTON -->
          <div class="edit-only-top-bar" >
            <div class="top-actions">
              <button class="icon-btn " (click)="onAddNewContact()">
                <span class="icon-text">+</span>
              </button>
            </div>
          </div>

          <!-- CONTACT SEARCH INPUT -->
          <div class="search-box">
            <input class="search-input"
                  placeholder="Search payer"
                  [(ngModel)]="searchInput">
            <span class="search-icon">⌕</span>
          </div>
          <!-- CONTACTS LIST-->
          <div class="topUp-scroll">
            <div class="table-list">
              <div class="row"
                  *ngFor="let c of filteredContacts()"
                  (click)="selectPayer(c)">
                <div class="contact-details">
                  <strong class="tx-title">
                    {{c.name}}
                  </strong>
                  <small class="tx-number">
                    {{c.displayNumber}}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ADD CONTACT -->
        <div *ngIf="showAddNewContact">
          <div class="back-btn"
              (click)="closeAddNewContact()">
            ←
          </div>
          <div class="section-title">New Payer</div>
              <!-- NAME -->
              <label class="field-label">Name</label>
              <input class="input"
                placeholder="Enter name"
                [(ngModel)]="newContactName"
                (ngModelChange)="contactNameValidationMessage=''">
              <div class="validation-message" *ngIf="contactNameValidationMessage">
                {{contactNameValidationMessage}}
              </div>

              <!-- WHATSAPP NUMBER -->
              <label class="field-label">WhatsApp Number</label>
              <div class="phone-input">
                <div class="phone-flag">
                  <img src="assets/images/sa-flag.png" class="flag-img">
                </div>
                <input
                class="phone-number-input"
                type="text"
                inputmode="numeric"
                maxlength="10"
                placeholder="Enter WhatsApp number"
                [(ngModel)]="newContactNumber"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onNewContactNumberInput($event)">
              </div>
              <div class="validation-message" *ngIf="contactWhatsappNumberValidationMessage">
                {{contactWhatsappNumberValidationMessage}}
              </div>
              <label class="save-beneficiary">
                <input type="checkbox" [(ngModel)]="saveContact">
                Save payer
              </label>

            <!-- BUTTONS -->
            <div class="btns mt-20px">
              <button class="set-authorization-btn"
                (click)="addNewContact()"
                [disabled]="isLoading || !newContactName || !whatsappNumberValid">
                <span *ngIf="!isLoading">Add</span>
              <span *ngIf="isLoading" class="spinner"></span>
              </button>
          </div>
        </div>
      </div>
      
      <!--  TRANSACTION SUMMARY -->
      <div *ngIf="showTransactionSummary">
        <div class="back-btn" (click)="return('topUpMethodsOrPayers')">
          ←
        </div>

        <div class="summary-table">
          <!-- AMOUNT -->
          <div class="grey-label">
              Amount
          </div>
          <div class="amount-box">
            <div class="currency">R</div>
              <input
                class="amount-input"
                type="text"
                inputmode="numeric"
                maxlength="6"
                placeholder="Enter amount"
                [(ngModel)]="amount"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onAmountInput();">
          </div>
          <div class="validation-message" *ngIf="amountValidationMessage">
            <div>{{amountValidationMessage}}</div>
          </div>
          <div *ngIf="showVoucherInput">
            <div class="voucherPin-label">
                1Voucher Pin
            </div>
            <input
                class="voucherPin-input"
                type="text"
                inputmode="numeric"
                maxlength="16"
                placeholder="Enter voucher pin"
                [(ngModel)]="voucherPin"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onVoucherInput($event)">
              <div class="validation-message" *ngIf="voucherPinValidationMessage">
                {{voucherPinValidationMessage}}
              </div>
          </div>
          <div class="grey-label">
            Transaction Summary
          </div>
          <div class="transactionSummary-card">
            <div class="detail-row" *ngIf="transactionTypeSummary">
              <div class="label">Transaction Type</div>
              <div class="colon"></div>
              <div class="value">{{transactionTypeSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="topUpMethodSummary">
              <div class="label">Top up Method</div>
              <div class="colon"></div>
              <div class="value">{{topUpMethodSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="beneficiarySummary">
              <div class="label">Beneficiary</div>
              <div class="colon"></div>
              <div class="value">{{beneficiarySummary}}</div>
            </div>
            <div class="detail-row" *ngIf="payerSummary">
              <div class="label">Payer</div>
              <div class="colon"></div>
              <div class="value">{{payerSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="payshapAccountSummary">
              <div class="label">Bank Account</div>
              <div class="colon"></div>
              <div class="value">{{payshapAccountSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="userAmountSummary">
              <div class="label">Amount</div>
              <div class="colon"></div>
              <div class="value">{{userAmountSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="serviceFeeSummary">
              <div class="label">Service Fee</div>
              <div class="colon"></div>
              <div class="value">{{serviceFeeSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="totalAmountToPaySummary">
              <div class="totalAmountToPay-card" >
                <div class="payment-option-left">
                  <span>{{ totalAmountToPayDescription }}</span>
                </div>
                <div class="colon"></div>
                <span
                  class="totalAmount-span"
                  [ngClass]="{
                    'amount-valid': amountValid,
                    'amount-invalid': !amountValid
                  }">
                  {{ totalAmountToPaySummary }}
                </span>
              </div>
            </div>
          </div>
          <!-- BUTTONS -->
          <div class="authorize-btns" *ngIf="showProcessButton">
            <button class="authorize-btn"
              (click)="ProcessTransaction()"
              [disabled]="isLoading || !amount || amount <= 0 || amount < topUpMinAmount || amount > topUpMaxAmount || (selectedTopUpMethod && selectedTopUpMethod.name !== 'Voucher' && amount>totalAmountToPay) || 
              (selectedTopUpMethod && selectedTopUpMethod.name === 'Voucher' && (voucherPin.length < 16 || voucherPin.length > 16 ))">
               <span *ngIf="!isLoading">{{processButtonText}}</span>
              <span *ngIf="isLoading" class="spinner"></span>
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Ok
          </button>
        </div>
      </div>
    </div>
  `
})
export class TopUpComponent{
  topUpMode = 'topUp';
  sessionToken = '';
  userId = '';
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  isLoadingPageContent = true;
  showPageContent = false;
  showErrorPopup = false;
  errorMessage = '';
  topUpMethods: any[] = [];
  contacts: any[] = [];
  walletBalance = 0;
  topUpMinAmount = 0
  topUpMaxAmount = 0;
  userNumber = '';
  userDisplayNumber = '';

   constructor(private router: Router, 
                  private topUpService: TopUpService,
                  private sessionService: SessionService,
                  private contactService: ContactService) {}
                  
      ngOnInit() {
        this.sessionToken = this.sessionService.getSession();
        if (!this.sessionToken) {
          this.errorMessage = 'Request failed, please reload page and try again.';
          this.showErrorPopup = true;
          return;
        }
        this.walletBalance = this.sessionService.getWalletBalance();
        this.getTopUpData();
      }
      getTopUpData() {
        this.topUpService
        .getTopUpData(this.sessionToken)
        .subscribe({
            next: response => {
              console.log(response);
              this.topUpMethods = response.topUpMethods.$values;
              this.contacts =  response.payers.$values;
              this.userNumber = response.userNumber;
              this.userDisplayNumber = response.userDisplayNumber;
              this.topUpMinAmount = response.topUpMinAmount;
              this.topUpMaxAmount = response.topUpMaxAmount;

              this.isLoadingPageContent = false;
              this.showPageContent = true;
            },
            error: err => {
              if (err.status === 401 || err.status === 404) {
                this.userId = this.sessionService.getUserId();
                this.router.navigateByUrl(
                  '/Login/' + this.userId,
                  { replaceUrl: true }
                );
                return;
              }
              this.errorMessage = err.error?.message ?? 'Unable to load page.';
              this.showErrorPopup = true;
              this.isLoadingPageContent = false;
            }
          },
        );
      }
  // =====================================================
  // TOP UP OPTIONS
  // =====================================================
  changeBuyMode(mode:string){
    if(mode === 'topUp'){
      this.transactionTypeSummary = 'Top Up';
      this.showPayerSection = false;
      this.showTopUpMethods = true;
      this.processButtonText = 'Procced';
      this.beneficiarySummary = '';
    }
    else if(mode === 'topMeUp'){
      this.searchInput = '';
      this.transactionTypeSummary = 'Top me up';
      this.beneficiarySummary = `Me (${this.userDisplayNumber})`;
      this.showPayerSection = true;
      this.showTopUpMethods = false;
      this.processButtonText = 'Send';
    }
    this.topUpMode = mode;
  }
  // =====================================================
  // TOP UP METHODS
  // ===================================================== 
  showTopUpMethods = true;
  selectedTopUpMethod:any = null;
  topUpMethodHeader = '';
  selectTopUpMethod(method:any){
    this.selectedTopUpMethod = method;
    this.showTopUpMethods = false;
    this.showPayerSection = false;
    this.topUpMethodHeader = this.selectedTopUpMethod.name
    this.topUpMethodSummary = method.name;
    this.showTransactionSummary = true;

    this.voucherPin = ''; 
    if(method.name === 'Voucher'){
      this.showVoucherInput = true;
    }
    else{
      this.showVoucherInput = false;
    }
  }
  // =====================================================
  // CONTACT
  // =====================================================
  newContactName = '';
  newContactNumber = '';
  newContactFormatedNumber = '';
  newContactDisplayNumber = '';
  contactNameValidationMessage = '';
  contactWhatsappNumberValidationMessage = '';
  showAddNewContact = false;
  selectedContact:any = null;
  showPayerSection = false;
  saveContact = false;
  whatsappNumberValid = false;

  selectPayer(contact:any){
    this.selectedContact = contact;
    this.showPayerSection = false;
    this.payerSummary = contact.name + ' ' + '('+ contact.displayNumber + ')';
    this.showTransactionSummary = true; 
    this.showVoucherInput = false;
    this.voucherPin = ''; 
  }
  filteredContacts() {
    let contacts = this.contacts;
    const search = this.searchInput.toLowerCase();
    return contacts.filter(x =>
      x.name.toLowerCase().includes(search) ||
      x.number.toLowerCase().includes(search) ||
      x.displayNumber.toLowerCase().includes(search)
    );
  }
  onAddNewContact(){
    this.showAddNewContact = true;
  }
  closeAddNewContact(){
    this.showAddNewContact = false;
    this.newContactName = '';
    this.newContactNumber = '';
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';
  }
  onNewContactNumberInput(){
    const validation =this.validatePhoneNumber();
       if(this.newContactNumber){
        if(!validation.isValid){
            this.contactWhatsappNumberValidationMessage = validation.message;
            this.whatsappNumberValid = false;
          }
          else{
            this.contactWhatsappNumberValidationMessage = '';
            this.whatsappNumberValid = true;
          }
      }
      else
        this.whatsappNumberValid = false;
  }
  addNewContact(){
    let hasError = false;
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';

    // NAME
    if(!this.newContactName.trim()){
      this.contactNameValidationMessage = 'Name is required';
      hasError = true;
    }
    // WHATSAPP NUMBER
    if(!this.newContactNumber.trim()){
      this.contactWhatsappNumberValidationMessage = 'WhatsApp number is required';
      hasError = true;
    }
    else{
      const validation =this.validatePhoneNumber();
      if(!validation.isValid){
        this.contactWhatsappNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      
    if(hasError){
      return;
    }
    this.payerSummary = this.newContactName + ' ' + '('+ this.newContactNumber + ')';

    if(this.saveContact){
      this.isLoading = true;
      this.contactService
      .postContact(this.sessionToken,
                this.newContactName,
                this.newContactFormatedNumber, 
                this.newContactDisplayNumber, 
                'TopUp')
      .pipe(
            finalize(() => this.isLoading = false)
          )
      .subscribe({
          next: response => {
            console.log(response);
            this.contacts = response.activeContacts.$values;
            this.selectPayer(response.newContact);
            return;
          },
          error: err => {
             if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            return;
          }
        },
      );
    }
    else{
      this.showPayerSection = false;
      this.showTransactionSummary = true;
    }
  }
  validatePhoneNumber(){
    let mobileRegexPattern = /^(0|\+27|27)[5-8][0-9][0-9]{7}$/;
    let phoneNumber = this.newContactNumber.trim().replace(/\s+/g, '');
    if(!mobileRegexPattern.test(phoneNumber)){
      return {
        isValid:false,
        message:'Invalid WhatsApp number'
      };
    }
    phoneNumber = phoneNumber.replace(/\D/g,'');// REMOVE NON NUMBERS
    if(phoneNumber.startsWith('0')){// CONVERT 076... -> 276...
      phoneNumber = phoneNumber.substring(1);
      phoneNumber = '27' + phoneNumber;
    }
    if(phoneNumber == this.userNumber){
      return {
        isValid:false,
        message:'You cannot add your number as a contact'
      };
    }
    // DISPLAY FORMAT
    let displayNumber = '0' + phoneNumber.substring(2);
    this.newContactFormatedNumber = phoneNumber;
    this.newContactDisplayNumber = displayNumber;
    return {
      isValid:true,
      message:'',
      formattedNumber:phoneNumber,
      displayNumber:displayNumber
    };
  }
   // =====================================================
  // TRANSACTION SUMMARY
  // =====================================================
  showTransactionSummary = false;
  transactionTypeSummary = 'Top Up';
  topUpMethodSummary = '';
  payerSummary = '';
  beneficiarySummary = ''
  payshapAccountSummary = '';
  userAmountSummary = '';
  serviceFeeSummary = '';
  totalAmountToPaySummary = '';
  // =====================================================
  // AMOUNT
  // =====================================================
  totalAmountToPayDescription = '';
  amountValidationMessage = '';
  amount: number | null = null;
  totalAmountToPay: number | null = null;
  serviceFee: number | null = null;
  dailyLimit = '';
  monthlyLimit = '';
    amountValid = false;

  onAmountInput(){
    this.amountValidationMessage = '';
      this.amountValid = false;

    if (this.amount == null) {
      this.userAmountSummary = '';
      this.totalAmountToPay = null;
      this.totalAmountToPaySummary = '';
      this.serviceFee = null;
      this.serviceFeeSummary = '';
      return;
    }
    else if (this.amount < this.topUpMinAmount) {
    this.amountValidationMessage =
      `Minimum amount is R${this.topUpMinAmount}`;
      this.userAmountSummary = '';
      this.totalAmountToPay = null;
      this.totalAmountToPaySummary = '';
      this.serviceFee = null;
      this.serviceFeeSummary = '';
    return;
    }
    if (this.amount > this.topUpMaxAmount) {
      this.amountValidationMessage =
        `Maximum amount is R${this.topUpMaxAmount}`;
        this.userAmountSummary = '';
      this.totalAmountToPay = null;
      this.totalAmountToPaySummary = '';
      this.serviceFee = null;
      this.serviceFeeSummary = '';
      return;
    }
    else{
      this.totalAmountToPay = this.amount;
      if(this.topUpMode === 'topUp'){
        if(this.selectedTopUpMethod.hasServiceFee){
          this.totalAmountToPayDescription = 'Total Amount';
          this.userAmountSummary = `R${this.amount}`;
          this.serviceFeeSummary = `R${this.selectedTopUpMethod.serviceFeeValue}`;
    
          if(this.selectedTopUpMethod.isFixedFeeType){

            this.serviceFee = this.selectedTopUpMethod.serviceFeeValue;
            this.totalAmountToPay = Number(this.amount) + Number(this.serviceFee);

            if(this.selectedTopUpMethod.name === 'Voucher'){
              this.totalAmountToPayDescription = 'Total Deposit Amount';
              this.totalAmountToPay = Number(this.amount) - Number(this.serviceFee);
            }
          }
          else{
            this.serviceFee = (Number(this.selectedTopUpMethod.serviceFeeValue) /100)*  Number(this.amount);
            this.totalAmountToPay = Number(this.amount) + Number(this.serviceFee);

             if(this.selectedTopUpMethod.name === 'Voucher'){
              this.totalAmountToPayDescription = 'Total Deposit Amount';
              this.totalAmountToPay = Number(this.amount) - Number(this.serviceFee);
             }

            this.serviceFeeSummary = `R${this.serviceFee.toFixed(2)}`;
          }
        }
        else{
          this.totalAmountToPayDescription = 'Amount';
          this.serviceFee = null;
          this.userAmountSummary = '';
          this.serviceFeeSummary = '';
        }
        this.totalAmountToPaySummary = `R${this.totalAmountToPay.toFixed(2)}`;
      }
      else if(this.topUpMode === 'topMeUp'){
        this.totalAmountToPayDescription = 'Amount';
        this.totalAmountToPaySummary = `R${this.totalAmountToPay}`;
      }
       // Amount is valid
      this.amountValid = true;
    }
  }
  // =====================================================
  // COMMON
  // =====================================================
  ProcessTransaction() {
  if(this.topUpMode === 'topUp'){
    this.isLoading = true;
    this.topUpService
    .postTopUp(this.sessionToken,
              this.selectedTopUpMethod.id,
              this.voucherPin, 
              this.amount, 
              this.serviceFee, 
              this.totalAmountToPay, )
    .pipe(
          finalize(() => this.isLoading = false)
        )
    .subscribe({
        next: response => {
          window.location.href = response.paymentURL;
        },
        error: err => {
           if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            if (err.status === 501) {
            this.voucherPinValidationMessage = err.error?.message;
            return
          }
          this.errorMessage = err.error?.message ?? 'Unable to load page.';
          this.showErrorPopup = true;
        }
      },
    );
  }
  else if(this.topUpMode === 'topMeUp'){
    this.isLoading = true;
    this.topUpService
    .postTopMeUp(this.sessionToken,
              this.amount, 
              this.selectedContact?.id ?? '',
              this.newContactName,
              this.newContactFormatedNumber,
              this.newContactDisplayNumber )
     .pipe(
          finalize(() => this.isLoading = false)
        )
    .subscribe({
        next: response => {
          window.location.href = this.whatsAppUrl;
        },
        error: err => {
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
        }
      },
    );
  }
}
closeErrorPopup(): void {
  this.showErrorPopup = false;
}
  searchInput = '';
  processButtonText = 'Procced';
  showVoucherInput = false;
  voucherPin = '';
  voucherPinValidationMessage = '';
  showProcessButton = true;

  return(view: string){
    this.voucherPinValidationMessage = '';
    this.showVoucherInput = false;
    this.voucherPin = ''; 
    if(view === 'topUpMethodsOrPayers'){
      this.amount = null;
      this.totalAmountToPaySummary = '';
      this.showTransactionSummary = false;
      if(this.topUpMode === 'topUp'){
        this.userAmountSummary = '';
        this.serviceFeeSummary = '';
        this.topUpMethodSummary = '';
        this.selectedTopUpMethod = null;
        this.showTopUpMethods  = true;
      }
      else if(this.topUpMode === 'topMeUp'){
        this.selectedContact = null;
        this.payerSummary = '';
        this.showPayerSection = true;

        if(this.saveContact){
          this.showAddNewContact = false;
          this.saveContact = false;
           this.newContactName = '';
          this.newContactNumber = '';
        }
      }
    }
  }
  onVoucherInput(value: string) {
    this.voucherPinValidationMessage = '';
    this.voucherPin = value.replace(/\D/g, '').slice(0, 16);
    const validation =this.validateVoucherPin();
    if(this.voucherPin){
      if(!validation.isValid){
        this.voucherPinValidationMessage = validation.message;
      }
      else{
        this.voucherPinValidationMessage = '';
      }
    }
  }
   validateVoucherPin(){
    let voucherPin = this.voucherPin.trim().replace(/\s+/g, '');
    // ONLY NUMBERS
    if(!/^\d+$/.test(voucherPin)){

      return {
        isValid:false,
        message:'Voucher PIN must contain only numbers'
      };
    }
    // LENGTH CHECK
    if(voucherPin.length < 16 || voucherPin.length > 16){
      return {
        isValid:false,
        message:'Voucher PIN must be 16 digits'
      };
    }
    // VALID
    return {
      isValid:true,
      message:''
    };
  }
allowOnlyNumbers(event: KeyboardEvent) {
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End'
  ];

  // Allow control keys
  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Block everything except digits
  if (!/^[0-9]$/.test(event.key)) {
    event.preventDefault();
  }
}
}